var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Radio, Flex } from "./..";
export var UncontrolledRadioGroup = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, value = _a.value, _c = _a.optionLss, optionLss = _c === void 0 ? {} : _c, onChangeFromProps = _a.onChange, onBlur = _a.onBlur, _d = _a.isInline, isInline = _d === void 0 ? false : _d, name = _a.name, _e = _a.required, required = _e === void 0 ? false : _e, props = __rest(_a, ["options", "value", "optionLss", "onChange", "onBlur", "isInline", "name", "required"]);
    var radioGroup = options.map(function (option, key) {
        var isChecked = value === option.value;
        // using the dot syntax to describe the name
        var uniqueName = name + "-" + option.value;
        return (React.createElement(Radio, __assign({}, props, { lss: __assign({ mb: 'sm', mr: 'md' }, optionLss) }, option, { required: required, defaultChecked: isChecked, name: name, key: "option-" + uniqueName + "-" + key, onChange: function () { return onChangeFromProps && onChangeFromProps(option.value); }, onBlur: onBlur })));
    });
    return (React.createElement(Flex, { lss: { flexDirection: isInline ? 'row' : 'column' } }, radioGroup));
};
var ControlledRadioGroup = function (_a) {
    var defaultValue = _a.defaultValue, otherProps = __rest(_a, ["defaultValue"]);
    var _b = __read(useState(defaultValue), 2), value = _b[0], setValue = _b[1];
    return (React.createElement(UncontrolledRadioGroup, __assign({}, otherProps, { value: value, onChange: setValue })));
};
/**
 * This component can work both as uncontrolled and controlled
 */
export var RadioGroup = function (props) {
    return typeof props.hasOwnProperty('value') ? (React.createElement(UncontrolledRadioGroup, __assign({}, props))) : (React.createElement(ControlledRadioGroup, __assign({}, props)));
};
//# sourceMappingURL=RadioGroup.js.map